module.exports = __webpack_public_path__ + "img/logo.73fc6457.png";